/**
 * package: com.inq.events
 * class: TextEvent
 * @extends com.inq.events.Event 
 * @constructor
 */
com.inq.events.TextEvent = function(type,bubbles,cancelable,text) {
	com.inq.events.Event.call(this,type);
};
$hxClasses['com.inq.events.TextEvent'] = com.inq.events.TextEvent;
/** @private @type {Array} */
com.inq.events.TextEvent.__name__ = ["com","inq","events","TextEvent"];
/** @private @type {Function} */
com.inq.events.TextEvent.__super__ = com.inq.events.Event;
for(var k in com.inq.events.Event.prototype ) com.inq.events.TextEvent.prototype[k] = com.inq.events.Event.prototype[k];
/** @private @type {string} */
com.inq.events.TextEvent.prototype.m_text = null;
/** @private @type {string} */
com.inq.events.TextEvent.prototype.text = null;
/** @type {com.inq.events.TextEvent} */
com.inq.events.TextEvent.prototype.__class__ = com.inq.events.TextEvent;
/** @type {string} */
com.inq.events.TextEvent.LINK = "link";

/** @type {string} */
com.inq.events.TextEvent.TEXT_INPUT = "textInput";

